export default "__VITE_ASSET__c1fa8051__"